import { List,Record } from "immutable";

import defaultFictionNarrativeLabels from "../../../../constants/defaultFictionNarrativeLabels";
import narrativeNumberingOptions from "../../../../constants/narrativeNumberingOptions";
import createFromJS from "../../../createFromJS";
import { NarrativeLabelRecord } from "./NarrativeLabelRecord";
const defaultLabelsList = List(defaultFictionNarrativeLabels).map(obj => NarrativeLabelRecord(obj));

export const NarrativeSettingsRecord = Record({
  labels: defaultLabelsList,
  autoDeleteWhenRemoveContainer: true,
  strictFolderStructure: false,
  numbering: narrativeNumberingOptions.OUTLINE_STYLE
});

const data = {
  collections: {
    labels: "NarrativeLabelRecord"
  }
};
createFromJS.registerCallback(
  "NarrativeSettingsRecord",
  createFromJS.createNestedCallback(NarrativeSettingsRecord, data)
);
